import { Breadcrumb, BreadcrumbButton, BreadcrumbItem, Button, makeStyles, Title2, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: tokens.spacingHorizontalL, marginBottom: tokens.spacingVerticalL },
  meta: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXS },
  actions: { display: 'flex', gap: tokens.spacingHorizontalS, flexWrap: 'wrap' },
});

export interface HeaderAction {
  label: string;
  onClick: () => void;
  appearance?: 'primary' | 'secondary' | 'subtle';
}

export const PageHeader = ({ title, subtitle, breadcrumbs = [], actions = [] }: { title: string; subtitle?: string; breadcrumbs?: string[]; actions?: HeaderAction[] }) => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <div className={styles.meta}>
        {breadcrumbs.length > 0 ? (
          <Breadcrumb>
            {breadcrumbs.map((item) => (
              <BreadcrumbItem key={item}>
                <BreadcrumbButton current>{item}</BreadcrumbButton>
              </BreadcrumbItem>
            ))}
          </Breadcrumb>
        ) : null}
        <Title2>{title}</Title2>
        {subtitle ? <span>{subtitle}</span> : null}
      </div>
      <div className={styles.actions}>
        {actions.map((action) => (
          <Button key={action.label} appearance={action.appearance ?? 'secondary'} onClick={action.onClick}>{action.label}</Button>
        ))}
      </div>
    </div>
  );
};
